var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarehouseProducts = function SvgWarehouseProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1E96A5",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.2,
    x: 1.6,
    y: 2.6,
    width: 18.8,
    height: 16.8,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M10.95 3.75v14.7h-1V3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M1.65 7.15h17.7v1H1.65zm0 4h17.7v1H1.65zm0 4h17.7v1H1.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.3,
    x: 5.65,
    y: 5.15,
    width: 1.7,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.3,
    x: 5.65,
    y: 17.15,
    width: 1.7,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.3,
    x: 14.65,
    y: 13.15,
    width: 1.7,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.3,
    x: 14.65,
    y: 9.15,
    width: 1.7,
    height: 1,
    rx: 0.5
  }))));
};

export default SvgWarehouseProducts;